module.exports = __webpack_public_path__ + "static/assets/15c5915bd35a7555fb5984d2b2a2d592.png";